import Vue from 'vue'
// import Vuetify, { VTabs, VTab, VTabsItems, VTabItem } from 'vuetify/lib'
import Vuetify from 'vuetify'
// import 'vuetify/dist/vuetify.min.css'

// const Vue = process.env.NODE_ENV === 'production' ? window.Vue : VuePack

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#8643bb',
        secondary: '#dac8f9',
        accent: '#212529',
        content: '#4c4250',
        gray100: '#f8f9fa',
        warning: {
          base: '#f1585e',
        },
      },
    },
  },
  icons: {
    iconfont: 'mdiSvg',
  },
})
